import api from '../api'; // Adjust the import path as needed
import {
  ICreateManualAttendanceRequest,
  ICreateManualAttendanceResponse,
  IPostAttendanceRequestBody,
  IPostAttendanceResponseBody,
  IPostAttendanceResponse,
  IPostAbsentRequestBody,
  IAbsentResponseBody,
  IPostPendingRequestBody,
  IPendingResponseBody,
  ICheckoutRequestBody,
  ICheckoutResponseBody,
  IFetchCutOffTimeResponseBody,
  IPostAttendancePayload,
  IAttendanceDeleteRequest,
  IAttendanceDeleteResponse,
} from '../../interface/attendanceModel';

// Function to post attendance data
export const getAttendanceRecord = async (
  data: IPostAttendanceRequestBody,
): Promise<IPostAttendanceResponseBody> => {
  try {
    const response = await api.post<IPostAttendanceResponseBody>('/attendance/record', data);
    return response.data;
  } catch (error: any) {
    throw new Error(`${error.message}`);
  }
};
export const postAttendance = async (
  data: IPostAttendancePayload,
): Promise<IPostAttendanceResponse> => {
  const response = await api.post('/attendance/student', data);
  return response.data;
};

export const ChekoutAttendance = async (
  data: ICheckoutRequestBody,
): Promise<ICheckoutResponseBody> => {
  try {
    const response = await api.post('/attendance/student/Checkout', data);
    return response.data;
  } catch (error: any) {
    throw new Error(`${error.message}`);
  }
};

export const AbsentAttendance = async (
  data: IPostAbsentRequestBody,
): Promise<IAbsentResponseBody> => {
  try {
    const response = await api.post('/attendance/student', data);
    return response.data;
  } catch (error: any) {
    throw new Error(`${error.message}`);
  }
};

export const asignAttendanceCutOff = async (data: string): Promise<IAbsentResponseBody> => {
  try {
    const response = await api.post('/attendance/cutoff', { time: `${data}` });
    return response.data;
  } catch (error: any) {
    throw new Error(`${error.message}`);
  }
};

export const updatAttendanceCutOff = async (
  data: string,
  id: string,
): Promise<IAbsentResponseBody> => {
  try {
    const response = await api.put(`/attendance/${id}`, { time: `${data}` });
    return response.data;
  } catch (error: any) {
    throw new Error(`${error.message}`);
  }
};

export const deletAttendanceCutOff = async (id: string): Promise<IAbsentResponseBody> => {
  try {
    const response = await api.delete(`/attendance/${id}`);
    return response.data;
  } catch (error: any) {
    throw new Error(`${error.message}`);
  }
};

export const fetchAttendanceCutOff = async (): Promise<IFetchCutOffTimeResponseBody> => {
  try {
    const response = await api.get('/attendance/cutoff');
    return response.data;
  } catch (error: any) {
    throw new Error(`${error.message}`);
  }
};

export const PendingAttendance = async (
  data: IPostPendingRequestBody,
): Promise<IPendingResponseBody> => {
  try {
    const response = await api.post('/attendance/student', data);
    return response.data;
  } catch (error: any) {
    throw new Error(`${error.message}`);
  }
};

export const deleteAttendance = async (
  data: IAttendanceDeleteRequest,
): Promise<IAttendanceDeleteResponse> => {
  try {
    const response = await api.delete('/attendance/delete/student', { data });
    return response.data;
  } catch (error: any) {
    throw new Error(`${error.message}`);
  }
};

/**
 * Create (or top up) the manual attendance sheet for a classroom on one date.
 *
 * No try/catch here on purpose: the api instance's response interceptor already
 * rejects with the backend body, and the thunk needs that body intact to read
 * `status`/`message`. Wrapping it in `new Error(error.message)` — as the older
 * helpers in this file do — would throw the status away.
 */
export const createManualAttendance = async (
  data: ICreateManualAttendanceRequest,
): Promise<ICreateManualAttendanceResponse> => {
  const response = await api.post('/attendance/create-manual', data);
  return response.data;
};
